import { makeStyles } from '../../../../../../styles';
export default makeStyles((theme) => ({
    wrapper: {
        flexDirection: 'column',
        position: 'relative',
        height: '100%',
    },
    header: {
        color: theme.colors.gray['700'],
        fontWeight: 600,
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(2),
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        background: theme.colors.gray['0'],
        width: `100%`,
        marginLeft: theme.spacing(-1),
        marginRight: theme.spacing(-5),
        padding: theme.spacing(1),
    },
}));
//# sourceMappingURL=MetricSelectorColumn.styles.js.map